import header     from "./base/header";
import menu       from "./base/menu";
import search     from "./base/search";
import slider     from "./base/slider";
import newsletter from './base/newsletter';
import accordion  from './base/accordion';
import instagram  from './base/instagram';
import modal      from './base/modal';

const init = () => {
  header();
  menu();
  search();
  slider();
  newsletter();
  accordion();
  instagram();
  modal();
};

document.addEventListener('DOMContentLoaded', init);